import { Body, Controller, Delete, Get, HttpCode, HttpStatus, Param, Post, UseGuards } from '@nestjs/common';
import { AdminSecretGuard } from '../common/guards/admin-secret.guard';
import { ApplicationsService } from './applications.service';
import { CreateApplicationDto } from './dto/create-application.dto';
import { IssueApiKeyDto } from './dto/issue-api-key.dto';

// Privileged, operator-only endpoints — registering a new consuming product
// and issuing it a key. Never called by a consuming product itself.
@UseGuards(AdminSecretGuard)
@Controller('applications')
export class ApplicationsController {
  constructor(private readonly applicationsService: ApplicationsService) {}

  @Post()
  create(@Body() dto: CreateApplicationDto) {
    return this.applicationsService.create(dto);
  }

  @Get()
  list() {
    return this.applicationsService.list();
  }

  @Post(':id/api-keys')
  issueApiKey(@Param('id') id: string, @Body() dto: IssueApiKeyDto) {
    return this.applicationsService.issueApiKey(id, dto);
  }

  @Delete(':id/api-keys/:keyId')
  @HttpCode(HttpStatus.NO_CONTENT)
  revokeApiKey(@Param('id') id: string, @Param('keyId') keyId: string) {
    return this.applicationsService.revokeApiKey(id, keyId);
  }
}
